import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { useAdminAuth } from "./AdminAuth";
import { formatApiError } from "../lib/api";
import { inputCls } from "./Fields";

const AdminLogin = () => {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await login(email, password); navigate("/admin"); }
    catch (ex) { setErr(formatApiError(ex)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-jannah-green-dark flex items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute inset-0 pattern-overlay opacity-20" />
      <form onSubmit={submit} className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl p-10" data-testid="admin-login-form">
        <img src="/logo.png" alt="Fly Jannah" className="h-16 mx-auto" />
        <h1 className="mt-6 text-2xl font-bold text-jannah-ink text-center flex items-center justify-center gap-2"><Lock size={20} className="text-jannah-gold" /> Admin Login</h1>
        <div className="mt-8 space-y-4">
          <div><label className="block text-xs font-semibold uppercase tracking-wide text-jannah-ink/60 mb-1.5">Email</label><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-login-email" /></div>
          <div><label className="block text-xs font-semibold uppercase tracking-wide text-jannah-ink/60 mb-1.5">Password</label><input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-login-password" /></div>
          {err && <p className="text-sm text-red-600" data-testid="admin-login-error">{err}</p>}
          <button type="submit" disabled={busy} className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-jannah-gold text-white font-bold uppercase tracking-wider text-sm hover:bg-jannah-green disabled:opacity-60" data-testid="admin-login-submit">
            {busy && <Loader2 size={16} className="animate-spin" />} Sign in
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;
